import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";

const PasswordRecovery = props => {
	useEffect(() => {
		return () => props.setPwReset(true);
	}, [props])

	return <Redirect push from="/passwordrecovery" to="/telluswhoyouare" />;
};

export default PasswordRecovery;
